import { FC, PropsWithChildren } from "react";

import {
  // Anchor,
  // Group, Text,
  Container,
  createStyles,
} from "@mantine/core";

const useStyles = createStyles((t) => ({
  wrapper: {
    flex: 1,
    width: "100%",
    display: "flex",
    overflow: "auto",
    gap: t.spacing.lg,
    padding: t.spacing.lg,
    paddingTop: 70,
    flexDirection: "column",
  },
}));

export const Content: FC<PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <>
      <Container className={classes.wrapper}>{children}</Container>
      {/* <Container w="100%">
        <Group position="left" py="lg">
          <Text size="sm" color="dimmed">
            &copy; Created by{" "}
            <Anchor
              target="_blank"
              href="https://www.linkedin.com/in/arbaz-ajaz/"
            >
              Arbaz Ajaz
            </Anchor>
          </Text>
        </Group>
      </Container> */}
    </>
  );
};
